<template lang='pug'>
.views-container
  gb-side-menu
  .loading-area(v-if="fetchLoading")
    vue-loading(
      type='spin'
      color="#F7CA18"
      :size="{ width: '60px', height: '60px' }"
    )
  .content-area(v-else)
    h3 メンテナンス
    .card
      gb-button.info(@clicked="toggleModal(true)") {{ buttonText }}
  transition(name="fade")
    template(v-if="isShowModal")
      gb-mask(:show="true")
        .card.modal
          .cancel-box(@click="toggleModal(false)")
            p.cancel-bottom ×
          h3.modal-text {{ modalText }}
          .button-wrapper(style="width: 100%; margin: 40px 0 64px; display: flex; justify-content: center")
            gb-button.info(
              @clicked="postMaintenanceStatus"
              :isLoading="isButtonLoading"
              style="width:300px;"
            ) {{ modalButtonText }}
</template>

<script>
import util from '@/api/util'
import { VueLoading } from 'vue-loading-template'

import GbSideMenu from '@/components/organisms/GbSideMenu.vue'
import GbMask from '@/components/atoms/GbMask.vue'
import GbButton from '@/components/atoms/GbButton.vue'

export default {
  components: {
    VueLoading,
    GbSideMenu,
    GbMask,
    GbButton
  },
  data () {
    return {
      fetchLoading: true,
      isShowModal: false,
      isButtonLoading: false,
      isMaintenance: false,
      buttonText: '',
      modalText: '',
      modalButtonText: ''
    }
  },
  created () {
    this.fetchMaintenance()
    // util.createMethod('COG', 'checkSessionExpired', null)
    //   .then(response => {
    //     if (response) {
    //       this.$router.push({ name: 'SignIn' })
    //     } else {
    //       this.fetchMaintenance()
    //     }
    //   })
  },
  methods: {
    async fetchMaintenance () {
      try {
        const SPR_REQUEST_VALUE = {
          type: 'admin'
        }
        const Response = (await util.createMethod('SPR', 'sprFetchMaintenance', SPR_REQUEST_VALUE)).data.data
        if (Response.is_maintenance) {
          this.buttonText = 'メンテナンスを終了する'
          this.modalText = 'メンテナンスを終了しますか？'
          this.modalButtonText = '終了'
        } else {
          this.buttonText = 'メンテナンスを開始する'
          this.modalText = 'メンテナンスを開始しますか？'
          this.modalButtonText = '開始'
        }
        this.isMaintenance = Response.is_maintenance
        this.fetchLoading = false
      } catch (error) {
        console.log('error', error)
      }
    },
    toggleModal (isOpen) {
      this.isShowModal = isOpen
    },
    async postMaintenanceStatus () {
      this.isButtonLoading = true
      try {
        const SPR_REQUEST_VALUE = {
          type: 'all',
          is_maintenance: !this.isMaintenance
        }
        const Response = (await util.createMethod('SPR', 'sprPostMaintenanceStatus', SPR_REQUEST_VALUE)).data.data
        this.isButtonLoading = false
        this.toggleModal(false)
        if (Response.message === 'ok') {
          let dialog
          if (!this.isMaintenance) dialog = 'メンテナンスを開始しました'
          else dialog = 'メンテナンスを終了しました'
          this.$swal.fire({
            text: `${dialog}`
          })
          this.fetchMaintenance()
        }
      } catch (error) {
        this.isButtonLoading = false
        this.toggleModal(false)
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
@import '../stylus/main.styl'
.card {
  padding 30px
  min-width 800px
  margin auto
  background-color #ffffff
  display flex
  justify-content center
  &.modal {
    padding 0
    flex-direction column
    align-items flex-end
  }
  .modal-text {
    width 100%
    text-align center
    margin 48px 0
  }
}

.cancel-box {
  cursor pointer
  width: 50px;
  height: 50px;
  border-bottom: 1px solid #000;
  border-left: 1px solid #000;
  display: grid;
  align-items: center;
  cursor pointer
  .cancel-bottom {
    font-size: 30px;
    text-align: center;
    font-weight: 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Maintenance.vue